// extracted by mini-css-extract-plugin
module.exports = {"labelText":"labelwarpper_labelText__26Olk","labelConatiner":"labelwarpper_labelConatiner__pXCgn","overAll":"labelwarpper_overAll__hKItB"};